import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useSelector} from 'react-redux';

const PrivateRoute = () => {
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const isAuthenticated = isLoggedIn || localStorage.getItem('token');
  //const token = useSelector((state: any) => state.auth.token);
  console.log("pv_r");
  console.log(isLoggedIn);
  // return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
